










































































import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import { forEach } from 'lodash';
import { BRow, BCol, BFormGroup } from 'bootstrap-vue';

import ZenMultiselect from '@reciprocity/multiselect';
import ZenButton from '@reciprocity/button';

import { downloadFile } from '@/utils';

import Block from './components/Block.vue';

export default Vue.extend({
  name: 'ExportPage',
  components: {
    BCol,
    BFormGroup,
    BRow,
    Block,
    ZenMultiselect,
    ZenButton,
  },
  data() {
    return {
      downloadingReport: false,
    };
  },
  computed: {
    ...mapGetters({
      configuration: 'export/configuration',
      configurationList: 'export/configurationList',
      selectedConfiguration: 'export/selectedConfiguration',
      route: 'route',
    }),
    configurationIsEmpty() {
      return this.configuration.length === 0;
    },
    configurationIsIncomplete() {
      let incomplete = false;
      forEach(this.configuration, block => {
        if (block.isIncomplete) {
          incomplete = true;
          return false;
        }
        return true;
      });
      return incomplete;
    },
  },
  watch: {
    route: {
      async handler() {
        if (this.route.params.configId) {
          await this.loadConfig(this.route.params.configId);
          if (this.configurationIsIncomplete) {
            this.showIncompleteWarning();
          }
        } else {
          this.clearConfig();
          this.addEmptyBlock();
        }
      },
      immediate: true,
    },
  },
  async created() {
    this.setPageTitle({ title: 'Data Export' });
    this.loadConfigList();
  },
  methods: {
    ...mapActions({
      setPageTitle: 'setPageTitle',
      updateBlock: 'export/updateBlock',
      deleteBlock: 'export/deleteBlock',
      addEmptyBlock: 'export/addEmptyBlock',
      clearConfig: 'export/clearConfig',
      loadConfig: 'export/loadConfig',
      loadConfigList: 'export/loadConfigList',
      generateReport: 'export/generateReport',
      showModal: 'modals/show',
      showAlert: 'alerts/show',
    }),
    resetState() {
      this.selectConfiguration({ id: null });
    },
    selectConfiguration(newConfiguration) {
      this.$router.replace({ params: { configId: newConfiguration.id } });
    },
    showIncompleteWarning() {
      this.showAlert({
        type: 'error',
        message:
          'Please review export! Some of the objects and/or' +
          ' attributes have been removed hence part of the export is not' +
          ' loaded.',
      });
    },
    async openSaveModal() {
      try {
        const id = await this.showModal({ type: 'ConfigSaveCard' });
        this.selectConfiguration({ id });
      } catch (e) {
        // User canceled modal
      }
    },
    async openDeleteModal() {
      try {
        await this.showModal({ type: 'ConfigDeleteCard' });
        this.resetState();
      } catch (e) {
        // User canceled modal
      }
    },
    async downloadReport(stripHtmlInExport) {
      this.downloadingReport = true;
      try {
        const reportData = await this.generateReport(stripHtmlInExport);
        this.downloadFile(reportData, 'text/csv', 'export_objects.csv');
      } catch (error) {
        this.showAlert({
          type: 'error',
          message: 'Oops, something went wrong.',
        });
      } finally {
        this.downloadingReport = false;
      }
    },
    async handleDownloadReportClick() {
      if (this.configurationIsIncomplete) {
        this.showIncompleteWarning();
        return;
      }

      const modalResponse = await this.showModal({
        type: 'ExportConfirmation',
        data: {
          objectType: '',
          exportQuery: '',
          actionUrl: '',
          csrfToken: '',
        },
      });

      const stripHtmlInExport = modalResponse ? modalResponse.stripHtmlInExport : false;
      await this.downloadReport(stripHtmlInExport);
    },
    downloadFile,
  },
});
